import { create } from "zustand";

import { AudioSliceState, createAudioSlice } from "./slices/audio";
import { CallSliceState, createCallSlice } from "./slices/call";
import {
  CompanyTagsSliceState,
  createCompanyTagsSlice,
} from "./slices/company_tags";
import {
  createEvaluationTabSourceSlice,
  EvaluationTabSourceSliceState,
} from "./slices/evaluation_tab_source";
import {
  createExpandedStateSlice,
  ExpandedStateSliceState,
} from "./slices/expanded_state";
import {
  createSearchContentMatchesSlice,
  SearchContentMatchesSliceState,
} from "./slices/search_content_matches";
import { createTagSlice, TagSliceState } from "./slices/tag";
import {
  createTimelineModeSlice,
  TimelineModeSliceState,
} from "./slices/timeline_mode";
import {
  createTranscriptionSettingsSlice,
  TranscriptionSettingsSliceState,
} from "./slices/transcription_settings";

export type BaseStoreState = TagSliceState &
  AudioSliceState &
  CallSliceState &
  TranscriptionSettingsSliceState &
  ExpandedStateSliceState &
  SearchContentMatchesSliceState &
  TimelineModeSliceState &
  CompanyTagsSliceState &
  EvaluationTabSourceSliceState;

export const useBaseStore = create<BaseStoreState>((...rest) => ({
  // asset page slices
  ...createTagSlice(...rest),
  ...createAudioSlice(...rest),
  ...createTranscriptionSettingsSlice(...rest),
  ...createExpandedStateSlice(...rest),
  ...createTimelineModeSlice(...rest),
  ...createSearchContentMatchesSlice(...rest),
  ...createCompanyTagsSlice(...rest),
  ...createEvaluationTabSourceSlice(...rest),
  ...createCallSlice(...rest),
}));
